import React, { useMemo } from "react";

const TabSearch = ({
  tabContainerStyle = {},
  placeholder = "",
  activeTab,
  typeValue,
  typing,
}) => {
  const isTyping = (e) => {
    if (typing) {
      typing(e.target.value);
    }
  };

  const getPlaceholder = (activeTab) => {
    switch (activeTab) {
      case "message":
        return "Search Messages";
      case "group":
        return "Search Groups";
      case "chart":
        return "Search Patients";
      case "contact":
        return "Search Contacts";
      case "create_chat":
        return "Search Contacts";
      case "facility":
        return "Search Facility";
      case "insurance":
        return "Search Facility";
      case "todos":
        return "Search Patient";
      default:
        return "";
    }
  };

  const _placeholder = useMemo(() => {
    return getPlaceholder(activeTab) || placeholder;
  }, [activeTab]);

  // Hide search input field when in conference tab
  if (activeTab === "conference") return "";

  return (
    <div className="Tab-Search-Container" style={tabContainerStyle}>
      <i className="fas fa-search"></i>
      <input
        onChange={(e) => isTyping(e)}
        id="search"
        placeholder={_placeholder}
        type="search"
        value={typeValue}
        autocomplete="off"
      />
    </div>
  );
};

export default TabSearch;
